import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./styles/iconAnimations.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { initMetaPixel } from "./utils/metaPixel";
import { initTikTokPixel } from "./utils/tiktokPixel";

initMetaPixel();
initTikTokPixel();

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
